import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import templateServices from '../../services/TemplateServices';
import { autorun } from 'mobx';


@inject('LayoutTemplateStore', 'AccountStore')
@observer
class FooterComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      comps: null,
      currentViewContainer: ""
    }
    this.LayoutTemplateStore = this.props.LayoutTemplateStore;
  }

  componentDidMount() {
      this.autorun = autorun(() => {
          let currentViewContainer = this.LayoutTemplateStore.currentViewContainer;
          if (this.state.currentViewContainer !== currentViewContainer) {
            let dataComps = [];
            if (this.LayoutTemplateStore.templateData.headerContainer != null) {
              let componentsByView = this.LayoutTemplateStore.templateData.footerContainer[currentViewContainer];
              if (componentsByView != null && componentsByView.length > 0) {
                dataComps = componentsByView || [];
              } else {
                dataComps = this.LayoutTemplateStore.templateData.footerContainer.formal || []
              }

            }
            this.setState({
                comps: templateServices.listComponentsByData(dataComps) || ( <div> </div>),
                  currentViewContainer: currentViewContainer
                });
            }

          });
      }

  componentWillUnmount() {
    this.autorun();
  }

  render() {    
    const { auth,type } = this.props.AccountStore.user;
    const {isNGC} = this.props.AccountStore;

    if(isNGC || !this.LayoutTemplateStore.isShowFooter) {
      return null;
    }

    return (
      <div id="footer" className={(auth ? " auth" : " noauth")+" "+type} className="footer_container">
          {this.state.comps}        
      </div>
    );
  }
  
}

export default FooterComponent;



// WEBPACK FOOTER //
// ./src/app/components/FooterComponent/index.js